<template>
    <div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row>
            <v-card  v-for="(item, i) in denoms" :key="i"
                    class="ma-4"
                    max-width="300">
                <v-img height="200" src="https://tri.co.id/image/files/tri20180515_sms_banner.png"></v-img>
                <v-card-title>{{item.name}}</v-card-title>
                <v-card-text>
                    Jumlah Token: {{item.jmltoken}}
                </v-card-text>
                <div class="ma-4 subtitle-1">
                    Rp {{formatAngka(item.price)}}
                </div>  
                <v-divider class="mx-4"></v-divider>
                <v-card-actions class="ml-3 mr-3">
                    <v-text-field label="Jumlah" style="width: 10%" v-model="item.jml" type="number">Jumlah</v-text-field>
                    <v-spacer></v-spacer>
<!--                    <v-btn text color="deep-orange" @click="createOrder(item)">Order</v-btn>-->
                    Total Bayar :
                    {{ formatAngka(parseInt(item.jml)*item.price)}}
                </v-card-actions>
                <v-divider class="mx-4"></v-divider>
                <div class="ma-4">
                    <v-btn block dark depressed @click="createOrder(item)" color="deep-orange">Beli Sekarang</v-btn>
                </div>
            </v-card>
        </v-row>
    </div>
</template>

<script>
    import {mapState,mapActions} from "vuex";

    export default {
        name: "SMSOrderOrderCreate",
        data: ()=>({
            jml:1,
            total_order:0

        }),
        mounted(){
           this.getDenoms();
        },
        computed: {
            ...mapState('TokenSMS', ['denoms', 'dialog', 'loading','overlay'])
        },
        methods: {
            ...mapActions('TokenSMS',['getDenoms','doCreateOrder']),
            createOrder(denom){
                this.$confirm('Yakin Order paket '+denom.name+' ?', { color: 'primary',title:'Konfm',icon:'fa-questions' }).then(res => {
                    if (res) {
                        this.doCreateOrder({paketid:denom.id,amount:denom.jml});
                    }
                })
            },
            formatAngka(angka) {
                var rev = parseInt(angka, 10).toString().split('').reverse().join('');
                var rev2 = '';
                for (var i = 0; i < rev.length; i++) {
                    rev2 += rev[i];
                    if ((i + 1) % 3 === 0 && i !== (rev.length - 1)) {
                        rev2 += '.';
                    }
                }
                return rev2.split('').reverse().join('').toString();
            }
        }
    }
</script>

<style scoped>

</style>
